import React, { useState } from 'react';
import { Box, CircularProgress, Grid, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';
import SendIcon from '@mui/icons-material/Send';
import { useTranslation } from 'react-i18next';
import { Cached } from '@mui/icons-material';
import ShareDialog from './ShareDialog';
import RealmMenu from './RealmMenu';

const RealmContainer = styled(Box)(({ theme }) => ({
  padding: '3px',
  background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.1) 100%), #121212;',
}));

const ActionText = styled('span')({
  cursor: 'pointer',
  color: 'rgba(255, 255, 255, 0.56)',
});

const StyledIconButton = styled(IconButton)({
  color: 'rgba(255, 255, 255, 0.56)',
});

const StyledLoader = styled(CircularProgress)(({ theme }) => ({
  marginRight: theme.spacing(2)
}));

const RealmSection = () => {
  const { t } = useTranslation();
  const [showShare, setShowShare] = useState(false);
  const [realmMenuAnchor, setRealmMenuAnchor] = useState(null);
  
  // Use selector hooks instead of connect
  const registryUrl = useSelector(state => state.registry.url);
  const ready = useSelector(state => state.common.ready);

  return (
    <RealmContainer>
      <Grid container alignItems="center" justifyContent="center">
        <Grid item>
          {ready ? (
            <Typography
              component="span"
              variant="subtitle1"
              color="inherit"
              target="_blank"
              rel="noopener noopener"
              noWrap
            >
              {registryUrl && registryUrl.Domain}
            </Typography>
          ) : (
            <StyledLoader size={21} />
          )}
        </Grid>
        {ready && (
          <Grid item xs={12}>
            <Grid container justifyContent="space-around">
              {registryUrl && (
                <Grid item>
                  <StyledIconButton size="small" onClick={() => setShowShare(true)}>
                    <SendIcon />
                  </StyledIconButton>
                  <ActionText onClick={() => setShowShare(true)}>
                    {t('share_site')}
                  </ActionText>
                </Grid>
              )}
              <Grid item>
                <StyledIconButton size="small" onClick={(e) => setRealmMenuAnchor(e.currentTarget)}>
                  <Cached />
                </StyledIconButton>
                <ActionText onClick={(e) => setRealmMenuAnchor(e.currentTarget)}>
                  {t('change_realm')}
                </ActionText>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
      <ShareDialog open={showShare} setOpen={setShowShare} />
      <RealmMenu anchorEl={realmMenuAnchor} setAnchorEl={setRealmMenuAnchor} />
    </RealmContainer>
  );
};

export default RealmSection;